import React, { useEffect, useState } from 'react'
import AInvbasicDetail from './AInvbasicDetail'
import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import { addInvoiceApi, getLatePaymentInterestListApi, getPenaltyInvoiceApi } from '../apiService'
import { globalGetService, globalPostService } from '../../../utils/globalApiServices'
import { checkApiStatus, normalizeTaxRate } from '../../../utils'
import { useSnackbar } from 'notistack'
import { NoRecordFound, PageLoader, titanAviationIntance } from '../../../shared_elements'
import { useNavigate } from 'react-router'
import moment from "moment";
import { useDispatch } from 'react-redux'
import { setFileUploadDetails, setUploadFiles } from '../../../shared_elements/actions'
import { trackActivity } from '../../../utils/mixpanel'
import { fieldDateFormat } from '../../../constants'
import { getAdditionalTax, getTotalTax } from '..'
import { getInvoiceDialogWidthProps } from './AInvItems'

const AddPenaltyInv = ({ onToggleModal, modeType, item, addEditInvoice, leaseSlug, invoiceSlug, getResponseBack }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [invoice, setInvoice] = useState({});
	const { enqueueSnackbar } = useSnackbar();
	const [error, setError] = useState({});
	const [check ,setCheck] = useState()
	const [tableErrors, setTableErrors] = useState({});
	const [attachments, setAttachments] = useState([]);
	const [isLoading, setLoading] = useState(false);
	const [isRefreshing, setIsRefreshing] = useState(false);
	const [latePaymentInterestInfo, setLatePaymentInterestInfo] = useState({});
	const [activeTaxList, setActiveTaxList] = useState([]);
	const [isQbEnabled, setIsQbEnabled] = useState(false);
    
	useEffect(() => {
		getLatePaymentInterestList();
	}, []);
    
	useEffect(() => {
		if (addEditInvoice?.data) {
			setInvoice(prev => ({
				...prev,
				start_date: addEditInvoice.data.start_date || null,
				end_date: addEditInvoice.data.end_date || null,
				asset: addEditInvoice?.data?.asset || null,
				invoice_items: Array.isArray(addEditInvoice.data.invoice_items)
					? addEditInvoice.data.invoice_items.map(item => ({
						sub_reference_id: item?.sub_reference_id || null,
					}))
					: prev?.invoice_items || [],
			}));
		}
	}, [addEditInvoice?.data]);
    
	const onAddEditInvoice = () => {
		let validationInputs = {
			invoice_number: invoice?.invoice_number?.trim()?.length ? '' : 'Please enter Invoice Number',
			date: invoice?.date ? '' : 'Please enter Invoice Date',
			due_date: invoice?.due_date ? '' : 'Please enter Invoice Due Date',
			start_date: invoice?.start_date ? '' : 'Please enter Period Start Date',
			end_date: invoice?.end_date ? '' : 'Please enter Period End Date',
			currency: invoice?.currency ? '' : 'Please select Currency',
			bank: invoice?.bank?.id ? '' : 'Please select Bank',
			from: addEditInvoice?.data?.from?.id ? '' : 'Please select From',
			to: addEditInvoice?.data?.to?.id ? '' : 'Please select To'
		}
		const invoiceDate = moment(invoice?.date);
		const dueDate = moment(invoice?.due_date);
		const maxAllowedDate = moment(invoice?.lease_end_date).add(3, 'months');
		if (invoice?.date && invoice?.due_date) {
			if (dueDate.isBefore(invoiceDate)) {
				validationInputs.due_date = "Due Date cannot be before invoice date";
			}
			if (invoiceDate.isAfter(dueDate)) {
				validationInputs.date = "Invoice Date cannot be after due date";
			}
			if (invoiceDate.isBefore(invoice?.lease_start_date)) {
				validationInputs.date = `Invoice Date cannot be before Lease Start Date (${moment(invoice?.lease_start_date).format(fieldDateFormat)})`;
			}
			if (invoiceDate.isBefore(invoice?.paid_date)) {
				validationInputs.date = `Invoice Date cannot be before Parent Invoice Paid Date (${moment(invoice?.paid_date).format(fieldDateFormat)})`;
			}
			if (invoiceDate.isAfter(maxAllowedDate)) {
				validationInputs.date = `Invoice Date must be within 3 months after the Lease End Date (${moment(invoice?.lease_end_date).format(fieldDateFormat)})`;
			}
			if (dueDate.isAfter(maxAllowedDate)) {
				validationInputs.due_date = `Due Date must be within 3 months after the Lease End Date (${moment(invoice?.lease_end_date).format(fieldDateFormat)})`;
			}
			if (dueDate.isBefore(invoice?.lease_start_date)) {
				validationInputs.due_date = `Due Date cannot be before Lease Start Date (${moment(invoice?.lease_start_date).format(fieldDateFormat)})`;
			}
		}
		setError({ ...validationInputs });

		// ----------------Item Table Condition-----------
		let newErrors = {};
		if ((((invoice?.due_date && invoice?.date && invoice?.invoice_number && invoice?.currency && invoice?.bank && invoice?.from && invoice?.to && !dueDate.isBefore(invoiceDate))) && invoice?.invoice_items?.length === 0)) {
			enqueueSnackbar('Please add at least one Invoice Item', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
			return
		}
		invoice.invoice_items.forEach((row, index) => {
			const errors = {};

			if (!row.invoice_item_name) {
                errors.invoice_item_name = "Please enter Invoice Item";
            }

			if (!titanAviationIntance && !row.description?.trim()) {
				errors.description = "Please enter Description";
			}

			if (isQbEnabled && !row.qb_product_and_service_id) {
				errors.qb_product_and_service_id = "Please select Product & Service";
			}

			if (isQbEnabled && !row.qb_chart_of_account_id) {
				errors.qb_chart_of_account_id = "Please select Chart of Account";
			}

			if (isQbEnabled && !row.qb_class_id) {
				errors.qb_class_id = "Please select Class";
			}

			if (isQbEnabled && !row.qb_sub_class_id) {
				errors.qb_sub_class_id = "Please select Sub Class";
			}

			if (Object.keys(errors).length > 0) {
				newErrors[index] = errors;
			}
		});
		setTableErrors(newErrors)
		if (!Object.keys(validationInputs).every((k) => validationInputs[k] === '') || Object.keys(newErrors).length > 0) {
			trackActivity(`Item Added`, { page_title: `Add Penalty Invoice`, error_msg: validationInputs, })
			return;
		}
		let payload = Object.assign({}, invoice)

		payload = {
			invoice_number: invoice?.invoice_number || null,
			start_date: invoice?.start_date || null,
			end_date: invoice?.end_date || null,
			date: invoice?.date || null,
			due_date: invoice?.due_date || null,
			currency: invoice?.currency?.code || null,
			bank: invoice?.bank || null,
			from: addEditInvoice?.data?.from || null,
			to: addEditInvoice?.data?.to || null,
			paid_date: invoice?.paid_date || null,
			parent_id: invoice?.parent_id || null,
			invoice_type: { label: 'Penalty', value: 3 },
			lease_slug: invoice?.lease_slug,
			remarks: invoice?.remarks || null, 
			asset : invoice?.asset ? invoice?.asset : null,
			footer_note : invoice?.bank?.footer_note || null,
			late_payment_interest : invoice?.late_payment_interest_id ? invoice?.late_payment_interest_id : null,
			invoice_items: Array.isArray(invoice?.invoice_items)
                ? invoice.invoice_items.map((items) => {
                      const subTotal = Number(items?.sub_total) || 0;
                      const taxRate = Number(items?.tax_rate) || 0;
                      const taxAmount = subTotal * (taxRate / 100);
                      const subAmountTotal = subTotal + taxAmount;
                      return {
				invoice_item_name: items?.invoice_item_name ? items?.invoice_item_name : null,
				description: items?.description ? items?.description : null,
				unit_description: items?.unit_description ? items?.unit_description : null,
				no_of_units: items?.no_of_units ? items?.no_of_units : null,
				days_late: items?.days_late ? items?.days_late : null,
				rate_per_unit: items?.rate_per_unit ? items?.rate_per_unit : null,
				paid_date: items?.paid_date ? items?.paid_date : null,
				parent_due_date: items?.parent_due_date ? items?.parent_due_date : null,
				sub_total: items?.sub_total ? items?.sub_total : null,
				principal_amount: items?.principal_amount ? items?.principal_amount : null,
				amount_paid: items?.amount_paid ? items?.amount_paid : null,
				tax_rate: normalizeTaxRate(items?.tax_rate),
				tax_amount: items?.tax_amount ? Number(items?.tax_amount) : 0,
				sub_amount_total: subAmountTotal.toFixed(4),
				sub_reference_id: items?.sub_reference_id || null,
				qb_product_and_service: items?.qb_product_and_service_id || null,
				qb_chart_of_account: items?.qb_chart_of_account_id || null,
				qb_class: items?.qb_class_id || null,
				qb_sub_class: items?.qb_sub_class_id || null,
			};
                  })
                : [],
        };
		let updatedInvoiceItems = getAdditionalTax(payload?.invoice_items, activeTaxList )
		let tax_details =  getTotalTax(payload?.invoice_items, activeTaxList)
		payload={ ...payload,
			tax_details:tax_details, 
			invoice_items: updatedInvoiceItems,
		}
		setLoading(true);
		globalPostService(addInvoiceApi(), { ...payload })
			.then(async(response) => {
				if (checkApiStatus(response)) {
					if (attachments?.length) {
						dispatch(setUploadFiles({ modal:true,slug: response?.data?.data?.slug }));
					}
					setLoading(false);
					onToggleModal()
					trackActivity('Item Added', { page_title: `Add Penalty Invoice`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
					navigate(`/invoices/view/${response?.data?.data?.slug}`)
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
				} else {
					setLoading(false);
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
					trackActivity('Item Added', { page_title: `Add Penalty Invoice`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
				}
			})
	};

	const onFieldChange = (keyParam, value, invoiceItem, itemIndex) => {
        if (invoiceItem) {
            if (keyParam === "sub_total" || keyParam === "tax_rate") {
                let taxAmount = 0;
                let subTotal = 0;

                if (keyParam === "sub_total") {
                    subTotal = parseFloat(value) || 0;
                    if (invoice.invoice_items[itemIndex].tax_rate) {
                        taxAmount = subTotal * (parseFloat(invoice.invoice_items[itemIndex].tax_rate) / 100);
                    }
                } else {
                    subTotal = parseFloat(invoice.invoice_items[itemIndex].sub_total) || 0;
                    if (value) {
                        taxAmount = subTotal * (parseFloat(value) / 100);
                    }
                }

                const subAmountTotal = subTotal + taxAmount;

                setInvoice({
                    ...invoice,
                    invoice_items: invoice.invoice_items.map((item, index) =>
                        index !== itemIndex
                            ? item
                            : {
                                ...item,
                                [keyParam]: value,
                                tax_amount: taxAmount.toFixed(4),
                                sub_amount_total: subAmountTotal.toFixed(4),
                            }
                    ),
                });
            } else {
                setInvoice({
                    ...invoice,
                    invoice_items: invoice.invoice_items.map((item, index) =>
                        index !== itemIndex ? item : { ...item, [keyParam]: value, ...(keyParam === 'qb_class_id' ? { qb_sub_class_id: null } : {}) }
                    ),
                });
            }
        } else {
            setInvoice({ ...invoice, [keyParam]: value });
        }
    };

	const onRestErrorKey = (keyParam) => {
		setError({ ...error, [keyParam]: '' })
	}

	const handleFileChange = (files) => {
		setAttachments(files);
		dispatch(setFileUploadDetails({ attachments: files }))
	};

	const resetTableError = (rowIndex, fieldName) => {
		setTableErrors((prevErrors) => {
			const rowErrors = { ...prevErrors[rowIndex] };
			delete rowErrors[fieldName];

			const updatedErrors = { ...prevErrors };
			if (Object.keys(rowErrors).length === 0) {
				delete updatedErrors[rowIndex];
			} else {
				updatedErrors[rowIndex] = rowErrors;
			}

			return updatedErrors;
		});
	};

	const getLatePaymentInterestList = () => {
		setLoading(true)
		globalGetService(getLatePaymentInterestListApi({ lease_slug: leaseSlug }))
			.then(response => {
				if (checkApiStatus) {
					setLatePaymentInterestInfo(response?.data?.data);
				}
				setLoading(false)
			})
	}

	const handleRefresh = () => {
		if (isRefreshing) return;
		setIsRefreshing(true);
		setCheck(undefined);
		globalGetService(getLatePaymentInterestListApi({ lease_slug: leaseSlug }))
			.then(response => {
				if (checkApiStatus(response)) {
					setLatePaymentInterestInfo(response?.data?.data);
				}
				setIsRefreshing(false);
			})
			.catch(() => {
				setIsRefreshing(false);
			});
	}

	const getPenaltyInvoice = () => {
			setLoading(true)
			globalGetService(getPenaltyInvoiceApi({invoiceSlug, late_payment_slug : check}))
				.then(response => {
					if (response?.data?.statusCode === 400) {
						handleRefresh();
					} else if (checkApiStatus) {
						setInvoice(prev => {
							const apiItems = response?.data?.data?.invoice_items || [];
							const prevItems = prev?.invoice_items || [];
							return {
								...response?.data?.data,
								asset: prev?.asset || response?.data?.data?.asset || null,
								invoice_items: apiItems.map((item, index) => ({
									...item,
									sub_reference_id: prevItems?.[index]?.sub_reference_id || item?.sub_reference_id || null,
								})),
							};
						});
					}
					setLoading(false)
				})
		}

	const toggleOps = (flag, item) => {	
				setCheck(item?.slug);	
	}
	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title:invoice?.is_penalty_invoice ? 'Add Penalty Invoice' : 'Select Late Payment Interest ', page_type: page_type, })
	}
	return (
		<>
			<Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' fullWidth open={true} {...(!invoice?.is_penalty_invoice ? { maxWidth: "sm" } : getInvoiceDialogWidthProps({ invoice: { ...invoice, invoice_type: { label: 'Penalty', value: 3 } }, type: 'penaltyInvoice', activeTaxList, showQbFields: isQbEnabled }, 'xl'))} >
				<DialogTitle sx={{ m: 0, p: 2, pl:3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='dialog-header' id="customized-dialog-title">
					{invoice?.is_penalty_invoice ? 'Add Penalty Invoice' : 'Select Late Payment Interest '}
					{!invoice?.is_penalty_invoice && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: "7px", marginBottom:'-15px' }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<Tooltip arrow title="Refresh">
								<span>
									<IconButton
										size='small'
										disabled={isRefreshing}
										onClick={() => { handleRefresh(); handleItemClicked('Refresh Icon') }}
									>
										{isRefreshing
											? <CircularProgress size={18} />
											: <RefreshIcon fontSize='small' />}
									</IconButton>
								</span>
							</Tooltip>
							<Button
								disabled={!leaseSlug}
								onClick={() => { window.open(`/lease/${leaseSlug}/lease-details/late_payment_interest`, "_blank"); handleItemClicked(latePaymentInterestInfo?.length === 0 ? 'Add Button' : 'View Button') }}
								variant='outlined'
								size='small'
							> {latePaymentInterestInfo?.length === 0 ? 'Add' : 'View'}
							</Button>
						</div>
						<Typography style={{ fontSize: "10px", display: "inline-block", background: "#ffff96", marginTop: '4px' }} >
							Note : Use the above button to manage SOFR.
						</Typography>
					</div>}
				</DialogTitle>
				<DialogContent dividers>
					{!invoice?.is_penalty_invoice ? <Grid container spacing={2}>
						<Grid item size={{ md: 12, xs: 12 }}>
							<TableContainer className="lease-detail-table" component={Paper} sx={{ maxHeight: 200, overflowX: "auto" }}>
								<Table stickyHeader className="mui-table-format">
									<TableHead>
										<TableRow>
											<TableCell sx={{ minWidth: '170px' }}> Name</TableCell>
											<TableCell sx={{ minWidth: '100px' }}> SOFR(%)</TableCell>
											<TableCell sx={{ minWidth: '100px' }}> Penalty(%)</TableCell>
											<TableCell sx={{ minWidth: '100px' }}> Action</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{latePaymentInterestInfo?.length > 0 && latePaymentInterestInfo.map((item, index) =>
										(
											<TableRow key={index}>
												<TableCell >{item?.name || '--'}</TableCell>
												<TableCell >{item?.sofr || 0}</TableCell>
												<TableCell >{item?.margin || 0}</TableCell>
												<TableCell > <Checkbox size='small' onChange={(e) => { toggleOps(e.target.checked, item); handleItemClicked(`Selected ${item?.name || 'Late Payment Interest'}`) }} checked={check === item?.slug} color='primary' sx={{ cursor: "pointer" }} /></TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
								{latePaymentInterestInfo?.length === 0 && <NoRecordFound />}
							</TableContainer>
						</Grid>
					</Grid> :
						<Grid container spacing={2}>
							<AInvbasicDetail addEditInvoice={invoice} type={'penaltyInvoice'} modeType={modeType} onFieldChange={onFieldChange} onRestErrorKey={onRestErrorKey} invoice={{...invoice, invoice_type: {label: 'Penalty', value: 3 }}} error={error} handleFileChange={handleFileChange} tableErrors={tableErrors} resetTableError={resetTableError} leaseSlug={leaseSlug} onActiveTaxLoad={setActiveTaxList} onQbStatusLoad={setIsQbEnabled}/>
						</Grid>}
				</DialogContent>
				<DialogActions sx={{ marginRight: "15px" }}>
					<Button className='cancel-btn' variant='outlined' size='small' disabled={isLoading} onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Cancel </Button>
					{!invoice?.is_penalty_invoice ? <Button variant='contained' disabled={latePaymentInterestInfo?.length === 0 || !check} className='btn-primary' size='small' onClick={() => { getPenaltyInvoice(); handleItemClicked('Proceed Button') }}>
						{isLoading ? <CircularProgress color='inherit' size={25} /> : "Proceed"}
					</Button> :
						<Button variant='contained' className='btn-primary' size='small' onClick={() => { onAddEditInvoice(); handleItemClicked('Save Button') }}>
							{isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
						</Button>}
				</DialogActions>
			</Dialog>
			{isLoading ? <PageLoader /> : null}
		</>
	)
}

export default AddPenaltyInv